import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMobileScreen,
  faLaptopCode,
  faServer,
  faDatabase,
  faCloud,
} from "@fortawesome/free-solid-svg-icons";

const skills = [
  {
    category: "Mobile",
    icon: faMobileScreen,
    items: ["Flutter", "Dart", "iOS", "Android"],
  },
  {
    category: "Frontend",
    icon: faLaptopCode,
    items: ["React", "Next.js", "TypeScript", "JavaScript", "HTML/CSS"],
  },
  {
    category: "Backend",
    icon: faServer,
    items: ["Node.js", "Express", "REST APIs", "Firebase"],
  },
  {
    category: "Database",
    icon: faDatabase,
    items: ["MongoDB", "MySQL", "Firestore"],
  },
  {
    category: "Cloud & DevOps",
    icon: faCloud,
    items: ["AWS (EC2, S3)", "Docker", "GitHub Actions", "CI/CD"],
  },
];

const Skills = () => {
  return (
    <section className="section" id="skills">
      <div className="section-inner">
        <div className="section-head reveal">
          <div className="eyebrow">What I Work With</div>
          <h2 className="section-title">Technical Skills</h2>
          <p className="section-subtitle">
            A toolkit built from shipping real products end to end.
          </p>
        </div>

        <div className="skills-grid">
          {skills.map((skill) => (
            <div className="skill-card reveal" key={skill.category}>
              <div className="skill-icon">
                <FontAwesomeIcon icon={skill.icon} />
              </div>
              <h3>{skill.category}</h3>
              <div className="skill-tags">
                {skill.items.map((item) => (
                  <span className="skill-tag" key={item}>
                    {item}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
